export default __webpack_public_path__ + "static/media/49.f619e9e0.png";